import { useState, useEffect, useRef } from 'react';
import axios from 'axios';

export function useFetch(url, initialValue = null) {
  const [data, setData] = useState(initialValue);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const isCurrent = useRef(true);

  useEffect(() => {
    return () => {
      isCurrent.current = false;
    };
  }, []);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    setLoading(true);

    try {
      const res = await axios.get(url);

      if (res.status === 200 && res.statusText === 'OK') {
        if (isCurrent.current) setData(res.data);
      }
    } catch (err) {
      if (isCurrent.current) setError(true);
    } finally {
      if (isCurrent.current) setLoading(false);
    }
  };

  return [data, loading, error];
}
